import styled from 'styled-components';

import { Box } from '@hivebrite/design-system/Box';
import { Button } from '@hivebrite/design-system/Button';
import { Card } from '@hivebrite/design-system/Card';
import { Container } from '@hivebrite/design-system/Container';

import { useMediaCenterPathContext } from 'hb-react/frontoffice/apps/MediaCenter/contexts/MediaCenterPathContext';
import { Link } from 'hb-react/frontoffice/components/Link';
import Grid, { Col, Row } from 'hb-react/shared/components/DesignSystem/Grid';
import { PAGES, usePageMenuName } from 'hb-react/shared/hooks/usePageMenuName';
import IconErrorFolder from 'hb-react/shared/icons/ErrorFolder';

const FolderNotFound = () => {
  const { mediaCenterPath } = useMediaCenterPathContext();
  const mediaCenterTabName = usePageMenuName(
    PAGES.MEDIA_CENTER,
    __('Media center'),
  );

  return (
    <Container height="auto">
      <Grid
        columnsInMobile
        mx={{ _: 0, l: 'unset' }}
        mb="100px"
        width="100%"
        mt={6}
      >
        <Row>
          <Col
            offset={({ numCols }) => ({
              _: 0,
              m: 2 / numCols,
            })}
            width={({ numCols }) => ({
              _: 6 / numCols,
              m: 8 / numCols,
            })}
          >
            <StyledWrapper>
              <StyledTitle mb={3}>
                {s__('MediaCenter|Folder not found')}
              </StyledTitle>
              <StyledText mb={8}>
                {s__('MediaCenter|Sorry, this folder was not found')}
              </StyledText>
              <Box display="block" color="primary" mb={6}>
                <IconErrorFolder height={120} width={120} />
              </Box>
              <Link to={{ pathname: mediaCenterPath() }} tabIndex={-1}>
                <Button>
                  {s__('MediaCenter|Go to %{name}').i__({
                    name: mediaCenterTabName,
                  })}
                </Button>
              </Link>
            </StyledWrapper>
          </Col>
        </Row>
      </Grid>
    </Container>
  );
};
export default FolderNotFound;

const StyledWrapper = styled(Card).attrs({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  width: '100%',
  height: '100%',
  alignItems: 'center',
})`
  padding: 48px;
`;

const StyledTitle = styled(Box).attrs({
  display: 'block',
  font: 'h3-semibold',
})``;

const StyledText = styled(Box).attrs({
  display: 'block',
  font: 'body-asphalt-italic',
})``;
